import { Injectable } from '@angular/core';

import { StorageService } from './storage.service';
import { DeliveryService } from './delivery.service';
import { CartService } from './cart.service';
import { CustomerService } from './customer.service';
import { ApiService } from './api.service';

import { ProductOrder, Customer, OnlineOrder, Checkout, PoptionalSelection } from '../models';
import { Utils } from '../helpers/utils';

import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PlaceOrderService {
  onlineOrder: OnlineOrder;

  deliveryInfo: {
    mode: string,
    address: string,
    district: string
  };

  items: ProductOrder[];
  districtObj: {bairro: string, valor: string};
  customer: Customer;

  constructor(private storageServ: StorageService,
    private deliveryServ: DeliveryService,
    private cartServ: CartService,
    private customerServ: CustomerService,
    private api: ApiService) {
    
  }

  authenticated(): boolean {
    this.customer = this.customerServ.getCustomer();
    this.districtObj = this.deliveryServ.getSelectedDistrictObj();

    return (!!this.customer && !!this.customer.token);
  }

  send(checkout: Checkout): Observable<any> {
    this.items = this.cartServ.getItems();

    this._prepareItems();
    this._prepareDeliveryInfo();

    this.onlineOrder = <OnlineOrder> {
      company_id: this.storageServ.getInLocal('current_company').id,
      product_orders_attributes: this.items,
      customer_id: this.customer.id,
      payment_type: checkout.paymentType,
      change_needed: checkout.changeNeeded,
      delivery_info: JSON.stringify(this.deliveryInfo)
    };

    return this._send();
  }

  private _send(): Observable<any> {
    return new Observable((obs) => {
      this.api.create('online_orders', {
        online_order: this.onlineOrder,
        token: this.customer.token
      }).subscribe(
        res => {
          this.cartServ.clear();
          obs.next(res);
        },
        err => {
          console.log(err);
          obs.error(err);
        },
        () => {obs.complete();}
      );
    });
  }

  private _prepareItems() {
    let prepared: ProductOrder[] = [];

    for(let item of this.items) {
      ProductOrder.setAdditionalData(item);
      prepared.push(<ProductOrder>{
        product_id: item.product.id,
        notes: item.notes,
        quantity: item.quantity,
        custom_price: item.custom_price,
        poptional_selections: this._preparePoptionals(item)
      });
    }

    this.items = prepared;
  }
  private _prepareDeliveryInfo() {
    this.deliveryInfo = {
      mode: null,
      address: null,
      district: null
    };

    if(this.customer.address) {
      this.deliveryInfo = {
        mode: 'delivery',
        address: this.customer.address,
        district: this.customer.district
      };
    } else {
      this.deliveryInfo = {
        mode: 'pickup',
        address: null,
        district: null
      }
    }
  }
  private _preparePoptionals(item: ProductOrder): PoptionalSelection[] {
    let selections: PoptionalSelection[] = item.poptional_selections;
    if(!selections)
      selections = [];

    let aux = [];
    for(let sel of selections) {
      let json = {
        id: sel.id,
        qty: sel.qty,
        local_id: sel.local_id,
        subpoptionals: []
      };
      for(let sub of sel.subpoptionals) {
        let subjson = {
          subpoptional_id: sub.id,
          local_id: sub.local_id,
          qty: sub.qty
        }
        json.subpoptionals.push(subjson);
      }
      aux.push(json);
    }
    return aux;
  }

  /*mountBill() {
    let deliveryObj: {bairro: string, valor: string} = this.delivery.getSelectedDistrictObj();
    let items = Utils.clone(this.cart_items);
    let customer = 
  }*/
}
